export const optionsTypesGastos = [
    { value:"Agua", label:"Agua" },
    { value:"Gas", label:"Gas" },
    { value:"Internet", label:"Internet" },
    { value:"Luz", label:"Luz" },
    { value:"Otros", label:"Otros" },
];